module.exports = __webpack_public_path__ + "static/media/phonecoverdesktoppage3.311f6d8f.png";